export const useStyles = theme => ({
  formGroup: {
    width: 'calc(50% - 40px)',
    display: 'inline-block',
    margin: '0 20px 25px',
    '& > label': {
      fontSize: '12px',
      color: '#303030',
      fontWeight: '500',
      display: 'block',
      marginBottom: '7px',
      fontFamily: 'acumin-pro-wide',
    },
    [theme.breakpoints.between('xs', 'sm')]: {
      width: 'calc(100% - 40px)',
    },
  },
  formGroupFullWidth: {
    width: 'calc(100% - 40px)',
    display: 'inline-block',
    margin: '0 20px 25px',
    '& > label': {
      fontSize: '12px',
      color: '#303030',
      fontWeight: '500',
      display: 'block',
      marginBottom: '7px',
      fontFamily: 'acumin-pro-wide',
    },
    [theme.breakpoints.between('xs', 'sm')]: {
      width: 'calc(100% - 40px)',
    },
  },
  inputField: {
    padding: '0',
    borderRadius: '5px',
    '& input': {
      height: '28px',
      padding: '10px 15px',
      fontFamily: 'acumin-pro',
    },
    '&  fieldset': {
      borderColor: 'rgba(48, 48, 48, 0.25)',
    },
    '& label': {
      fontStyle: 'italic',
      opacity: '50%',
      fontSize: '16px',
      transform: 'translate(15px, 16px) scale(1)',
    },
  },
});
